
<template>
  <div>
    <el-tabs v-model="filterActiveNameBc" type="card" size="mini">
      <el-tab-pane v-if="showBtnList.includes('xp')" name="xp">
        <span slot="label" class="arrow-icon" @click="filterClick('xp')"
          >新品<i
            :class="['el-icon-caret-top', xpState ? 'hiddenClass' : '']" /><i
            :class="['el-icon-caret-bottom', !xpState ? 'hiddenClass' : '']"
        /></span>
      </el-tab-pane>
      <el-tab-pane
        v-if="showBtnList.includes('jg')"
        name="jg"
        class="no-padding-left"
      >
        <span slot="label" class="arrow-icon" @click="filterClick('jg')"
          >价格<i
            :class="['el-icon-caret-top', jgState ? 'hiddenClass' : '']" /><i
            :class="['el-icon-caret-bottom', !jgState ? 'hiddenClass' : '']"
        /></span>
      </el-tab-pane>
      <el-tab-pane
        v-if="showBtnList.includes('rl')"
        name="rl"
        class="no-padding-right"
      >
        <span slot="label" class="arrow-icon" @click="filterClick('rl')"
          >容量<i
            :class="['el-icon-caret-top', rlState ? 'hiddenClass' : '']" /><i
            :class="['el-icon-caret-bottom', !rlState ? 'hiddenClass' : '']"
        /></span>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    showBtnList: {
      type: Array,
      default() {
        return ['xp', 'jg', 'rl'];
      },
    },
    state: {
      type: Object,
      default() {
        return {
          xp: 'newSort',
          jg: 'priceSort',
          rl: 'capacitySort',
        }
      }
    },
  },
  data() {
    return {
      filterActiveNameBc: '',
      xpState: true,
      jgState: true,
      rlState: false,
      param: '',
    };
  },
  methods: {
    // 排序
    filterClick(val) {
      this[`${val}State`] = !this[`${val}State`];
      this.param = this[`${val}State`] ? 'desc' : 'asc';
      this.$emit('change-list', this.state[val], this.param);
    },
    onReset() {
      this.filterActiveNameBc = '';
      this.param = '';
      this.jgState = false;
      this.rlState = false;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .arrow-icon {
  position: relative;
  padding-right: 10px;
  .el-icon-caret-top,
  .el-icon-caret-bottom {
    position: absolute;
    left: 28px;
    top: -5px;
  }
  .el-icon-caret-bottom {
    top: 5px;
  }
  .hiddenClass {
    color: #333;
  }
}
</style>